import gsap, { Power2 } from 'gsap';
import { Basics, isTouch } from '../_app/cuchillo/core/Basics';

import { GetBy } from '../_app/cuchillo/core/Element';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import { ScrollItem__BlockDefault } from './ScrollItem__BlockDefault';

class ScrollItem__InfoAnchors extends ScrollItem__BlockDefault {
  _target;
  _titles;

  // _click = (e) => this.filter(e);
  // _enter = (e) => this.hoverIn(e);
  // _leave = (e) => this.hoverOut();

  //==================================================================================================================
  //          CONSTRUCTOR
  //==================================================================================================================
  constructor(__link, __index, __scroller) {
    super(__link, __index, __scroller);
  }

  setAnimations() {
    this._target = GetBy.class('__target', this.item)[0];
    this._titles = GetBy.selector('[data-title]');

    for (let i = 0; i < this._titles.length; i++) {
      const title = this._titles[i];
      const anchor = document.createElement('a');
      anchor.href = `#${title.id}`;
      anchor.className = 'button --border';
      anchor.textContent = title.dataset.title;

      this._target.appendChild(anchor);
    }

    super.setAnimations();
  }

  //==================================================================================================================
  //          PUBLIC
  //==================================================================================================================
  // filter(e) {
  // const btn = e.target;

  // if (btn.classList.contains('--active')) btn.classList.remove('--active');
  // else btn.classList.add('--active');

  // const filters = [];
  // for (let i = 0; i < this._filters.length; i++) {
  //   const f = this._filters[i];

  //   if (f.classList.contains('--active')) {
  //     filters.push(f.dataset.categ);
  //   }
  // }

  // for (let i = 0; i < this._projects.length; i++) {
  //   const p = this._projects[i];
  //   p.classList.remove('--active');

  //   for (let i = 0; i < filters.length; i++) {
  //     const filter = `categ-${filters[i]}`;

  //     if (p.classList.contains(filter)) {
  //       p.classList.add('--active');
  //     }
  //   }
  // }
  // }

  // hoverIn(e) {
  //   for (let i = 0; i < this._projects.length; i++) {
  //     const p = this._projects[i];

  //     if (p !== e.target) {
  //       p.classList.add('--hover-out');
  //     } else {
  //       p.classList.add('--hover-in');
  //     }
  //   }
  // }

  // hoverOut() {
  //   for (let i = 0; i < this._projects.length; i++) {
  //     const p = this._projects[i];
  //     p.classList.remove('--hover-out');
  //     p.classList.remove('--hover-in');
  //   }
  // }

  dispose() {
    super.dispose();
    // for (let i = 0; i < this._filters.length; i++) {
    //   this._filters[i].removeEventListener(Basics.clickEvent, this._click);
    // }

    // if (!isTouch) {
    //   for (let i = 0; i < this._projects.length; i++) {
    //     this._projects[i].removeEventListener(Basics.mouseOver, this._enter);
    //     this._projects[i].removeEventListener(Basics.mouseOut, this._leave);
    //   }
    // }
  }
}

Scroll._registerClass('info-anchors', ScrollItem__InfoAnchors);